<template>
  <section>
    <div @click="showModal">
      <icon-svg icon="ServicosRealizados"
                class="icon-simple-pecil ml-3" />
    </div>
    <b-modal :id="`modalMensalista${propMensalista.mensalista_id}`"
             centered
             size="xl"
             hide-footer>
      <div class="custom-control custom-switch">
        <input :id="propMensalista.mensalista_id"
               type="checkbox"
               :checked="statusPedidos"
               class="custom-control-input"
               @click="handlerStatus">
        <label class="custom-control-label"
               for="customSwitch1"
               @click="handlerStatus(mensalista)" />
        <span class="label">Mostrar apenas serviços com pendências</span>
      </div>
      <div class="mt-3">
        <span>Périodo</span>
        <div class="d-flex align-items-center pt-2">
          <b-form-input v-model="dataInicial"
                        class="inputs-data"
                        type="date" />
          <span class="pl-2 pr-2">até</span>
          <b-form-input v-model="dataFinal"
                        class="inputs-data" 
                        type="date" />
          <b-button class="btn-filtrar"
                    variant="outline-primary"
                    @click="pesquisar">
            Filtrar
          </b-button>
          <!-- <b-button class="btn-filtrar"
                    variant="outline-primary"
                    @click="resetFiltro">Reset</b-button> -->
        </div>
      </div>
      <div class="box-tabela">
        <div class="d-flex ">
          <h3 class="nome-mensalista">
            {{ propMensalista.nome_empresa }}
          </h3>
          <input v-mask="['###.###.###-##', '##.###.###/####-##']"
                 class="input-cpf"
                 type="text"
                 :value="propMensalista.cpf_cnpj">
        </div>
        <TabelaMensalista :prop-mensalista="mensalista" />
      </div>
    </b-modal>
  </section>
</template>

<script>
  // Components
  import MensalistaService from '../mensalistaService'
  import TabelaMensalista from './TabelaMensalista.vue'

  export default ({
    name: 'ModalMensalista',
    components: {
      TabelaMensalista,
    },
    props: {
      propMensalista: {type: Object, default: null}
    },
    data () {
      return {
        mensalista: [],
        statusPedidos: false,
        dataInicial: null,
        dataFinal: null
      }
    },
    created () {
      this.mensalista = this.propMensalista
    },
    methods: {
      showModal () {
        this.$bvModal.show(`modalMensalista${this.propMensalista.mensalista_id}`)
      },
      handlerStatus () {
        this.statusPedidos = !this.statusPedidos
      },
      async pesquisar () {
        loader ({text: 'Buscando pedidos', active: true})
        try {
          const paylod = {
            id: this.propMensalista.mensalista_id,
            dataInicial: this.dataInicial,
            dataFinal: this.dataFinal,
            statusPedidos: this.statusPedidos
          }
          const mensalistaPedidos = await MensalistaService.buscarById(paylod)
          this.mensalista = mensalistaPedidos[0]
        } catch {

        } finally {
          loader({text: null, active: false})
        }
      },
      // resetFiltro () {
      //   this.mensalista = this.propMensalista
      // },
    }
  })
</script>

<style lang="scss" scoped>
.icon-simple-pecil {
  fill: gray;
  height: 40px;
  width: 45px;
}
.label {
  font-size: 1.2rem;
}
.inputs-data {
  max-width: 18%;
  padding-top: 24px;
  padding-bottom: 24px;
  font-size: 1.1rem;
}
.btn-filtrar {
  margin-left: 40px;
  font-size: 1.1rem;
  padding-left: 20px;
  padding-right: 20px;
  transform: scale(1.2);
}
.box-tabela {
  margin-top: 20px;
  padding: 1rem;
  border: solid 1px black;
  .input-cpf {
  border: none;
  outline: none;
  font-size: 1.6rem;
  font-weight: bold;
  }
  .nome-mensalista {   
    font-size: 2rem;
    &::after {
      content: '-';
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}

</style>
